import React, { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import {
  ArtistContactDetailsForm,
  FormDataProps,
} from 'src/Components/ArtistContactDetailsForm'

import { MetaAdsResourceDetails } from './MetaAdsResourceDetails'

const Container = styled.div`
  display: flex;
  padding: 24px 40px 24px 24px;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.lightGrey};
  background-color: ${(props) => props.theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: column;
    padding: 0;
    border: none;
    box-shadow: none;
  }
`

const StyledArtistContactDetailsForm = styled(ArtistContactDetailsForm)`
  flex-basis: calc(50% - 48px);

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-basis: unset;
  }
`

interface MetaAdsRegisterContentProps {
  isEmailExist: boolean
  clearEmailExist: () => void
  isRegisterLoading?: boolean
  onSubmitRegisterForm: (data: FormDataProps, token: string) => Promise<void>
  onGoogleClick: () => void
  onStartFillingForm: () => void
  isResourceDataLoading?: boolean
  resourceCoverUrl?: string
  resourceName?: string
  ownerName?: string
  duration?: string
  trackPreviewUrl?: string
  isPlaylist?: boolean
}

export const MetaAdsRegisterContent: FC<MetaAdsRegisterContentProps> = ({
  onSubmitRegisterForm,
  onGoogleClick,
  isRegisterLoading,
  onStartFillingForm,
  isEmailExist,
  clearEmailExist,
  isResourceDataLoading,
  resourceCoverUrl,
  resourceName,
  ownerName,
  duration,
  trackPreviewUrl,
  isPlaylist,
}) => (
  <Container>
    <StyledArtistContactDetailsForm
      onSubmit={onSubmitRegisterForm}
      onGoogleClick={onGoogleClick}
      isEmailExist={isEmailExist}
      clearEmailExist={clearEmailExist}
      onStartFillingForm={onStartFillingForm}
      loading={isRegisterLoading}
    />

    <MetaAdsResourceDetails
      coverUrl={resourceCoverUrl}
      resourceName={resourceName}
      ownerName={ownerName}
      duration={duration}
      trackPreviewUrl={trackPreviewUrl}
      isResourceDataLoading={isResourceDataLoading}
      isPlaylist={isPlaylist}
    />
  </Container>
)
